module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Da-Gc-Ha 后背.9342eba7.png";